import { useAuth } from '@sonnen/web-utils/hooks';
import { useAppContext } from '../../AppContext/AppContext';
import { OfferCalculationPage } from '../../components/OfferCalculationPage/OfferCalculationPage';
import { useTranslation } from '../../i18n/i18n';
import { OrderFlow } from '../../types';
import EnergyDynamicOverview from './EnergyDynamicOverview/EnergyDynamicOverview';
import EnergyFixOverview from './EnergyFixOverview/EnergyFixOverview';

const TariffOverview = () => {
  const { t } = useTranslation();
  const { orderFlow } = useAppContext();
  const { authenticated } = useAuth();
  const energyDynamic = orderFlow === OrderFlow.energyDynamic;
  const energyFix = orderFlow === OrderFlow.energyFix;
  const scope = energyFix ? 'energyFix' : 'energyDynamic';

  return (
    <OfferCalculationPage dataTestId="tariff-overview" title={t(`tariffOverview.${scope}.title`)}>
      {(energyDynamic || !authenticated) && <EnergyDynamicOverview />}
      {energyFix && <EnergyFixOverview />}
    </OfferCalculationPage>
  );
};

export default TariffOverview;
